// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"560b2246","239":"61e83864","455":"0feedda9","488":"e316de63"}[chunkId] + ".chunk.js";
};